/**
 * Serializace Date pro API tak, aby zustal zachovan lokalni den.
 * Date.toISOString() prevadi do UTC, takze 1.1.2026 00:00 CET se posle
 * jako 2025-12-31T23:00:00Z a report pak pracuje s obdobim "od 31.12.2025".
 */
export const toApiDateTime = (date: Date): string =>
  new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString()
